import { CustomQuillMention } from "@app/models";

export function compareNumericAscending(value1: number, value2: number): number {
    return value1 - value2;
}

export function compareNumericDescending(value1: number, value2: number): number {
    return value2 - value1;
}

export function compareByDefaultOrder(value1: any, value2: any): any {
    return value1 - value2;
}

export function compareStringAlphabetical(value1: string, value2: string, options?: Intl.CollatorOptions): number {
    return value1.localeCompare(value2, undefined, options ?? { sensitivity: 'base' });
}

// remove keys from object if they have no or falsy values 
export function removeFalsyValues(data: {[k:string]: any}) {
    let newData: {[k:string]: any} = {};

    Object.keys(data).forEach((key) => {
        if (data.hasOwnProperty(key) && data[key]) {
            newData[key] = data[key];
        }
    });

    return newData;
}

// check if the object has values, not empty
export function hasValuesInObject(data: any) {
    return (JSON.stringify(data) != '{}');
}

export function convertNullValueIfZero(value: any) {
    return value === 0 ? null : value;
}

export function convertNumberArray(value: any) {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value
      .map(v => typeof v === 'number' ? v : Number(v))
      .filter(v => typeof v === 'number' && !isNaN(v));
  }
  const num = typeof value === 'number' ? value : Number(value);
  return typeof num === 'number' && !isNaN(num) ? [num] : [];
};

// Transforms custom fields filters into table row format for preview display
export function appendCustomFieldsToTableData(
  customFieldsFilters: any,
  customFieldsMeta: any[],
  tableData: { name: string; value: string }[]
): void {
  if (!customFieldsFilters || !customFieldsMeta || !Array.isArray(customFieldsMeta)) {
    return;
  }

  const { fieldIds = [], valueIds = [] } = customFieldsFilters;

  (fieldIds as number[]).forEach((fieldId: number) => {
    const field = customFieldsMeta.find((f: any) => f.field_id === fieldId);
    
    if (field) {
      const selectedValues = (field.values || [])
        .filter((v: any) => valueIds.includes(v.value_id))
        .map((v: any) => v.value);

      if (selectedValues.length) {
        tableData.push({
          name: field.field_name,
          value: selectedValues.join(', ')
        });
      }
    }
  });
}

export function removeCustomQuillMentions(mentions: CustomQuillMention[],content: string | null | undefined, triggerCharacter: string = "@") {
  const mentionOptions = mentions.map(mention => mention.id);

  if (content?.trim()?.length) {
      return mentionOptions.reduce((acc, mention) => {
          const mentionText = `${triggerCharacter}${mention}`;
          return acc.split(mentionText).join("");
      }, content);
  }

  return content;
}